import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { logError } from "@faire/web--source/common/logging";
import { getSettingFacebookRetailerPixelId } from "@faire/web--source/common/settings/getSettingFacebookRetailerPixelId";
export var facebookInterceptor = function(params) {
    if (params.facebookPixelEvent) {
        try {
            emitFacebookPixelEvent(params.facebookPixelEvent, params.pixelCustomDataParams, {
                eventID: params.eventId
            });
        } catch (_) {
        /* ignore */ }
    }
};
export var emitFacebookPixelEvent = function(event, vars, context) {
    var fbq = getGlobalProperty("fbq");
    // NOTE(luke): We originally split facebookRetailerPixelId and facebookMakerPixelId,
    // but consolidated them when moving to PETE-driven facebook pixel events.
    var facebookRetailerPixelId = getSettingFacebookRetailerPixelId();
    if (!fbq) {
        logError("fbq not initialized");
        return;
    } else if (!facebookRetailerPixelId) {
        if (getGlobalProperty("envName") === "production") {
            logError("facebookRetailerPixelId is not specified");
        }
        return;
    }
    fbq("trackSingleCustom", facebookRetailerPixelId, event, vars, context);
};
